<template>
    <div style="transition-delay: 0s" v-if="questionnaires" class="pl-lg-2 ml-lg-2 mt-4 mt-lg-0">
        <h3 class=" mt-lg-0">Latest {{ (is_vote === 1 ? 'Vote' : 'Survey') }}{{ questionnaires.length > 1 ? 's' : '' }}</h3>
        <div v-if="questionnaires.length > 0">

            <section v-for="questionnaire in questionnaires" v-bind:key="'questionnaire_'+questionnaire.userid" class="question container text-left p-0 col-12 mb-0 mt-4" :class="is_vote ? 'mb-4' : ''">
                <template :id="'questionnaire_'+questionnaire.id">
                    <div class="card-header" v-if="is_vote !== 1">
                        <i class="float-right " :class="questionnaire.is_anonymous ? 'anonymous fas fa-user-secret' : ''"></i> {{ questionnaire.name }}
                    </div>
                    <div class="card-body row" v-if="is_vote === 1">
                        <transition name="slide-up">
                            <div class="col-12 col-lg mb-lg-0" v-for="questions in questionnaire.questions" v-bind:key="'questions'+questions.id" :id="'q_'+questions.id" v-if="!completed.includes(questions.id)">
                                <h5 class="font-italic font-weight-light">{{ questions.question }}</h5>
                                <div class="row mt-3">
                                    <div class="col-6 mt-3" v-for="options in questions.options" :class="(maxOptionLength > 30 ? 'col-12' : '')">
                                        <button class="options btn w-100 py-1"
                                                :rel="'a_' + options.id"
                                                :id="'a_' + options.id"
                                                :class="answered && answered.includes(options.id) ? 'btn-primary' : 'btn-light'"
                                                @click="saveResponse({'questionnaire_id' : questionnaire.id, 'question_id' : questions.id, 'answered' : options})">
                                            <span v-if="options.option != null">{{ options.option }}</span>
                                            <img class="option_icon" v-else :src="require('@/assets/icons/'+options.questionnaire_icon)" :alt="options.alt_text"/>
                                        </button>
                                    </div>
                                </div>
                                <hr>
                                <div class="row pt-1">

                                    <div class="col-6" v-if="is_vote === 1">
                                        <button class="btn noThanksButton col-12"
                                                @click="saveResponse({'questionnaire_id' : questionnaire.id, 'question_id' : questions.id, 'answered' : {'id' : null}})">
                                            <span>Don't Participate</span>
                                        </button>
                                    </div>
                                    <div class="col-6">
                                        <button class="btn btn-primary col-12" @click="postResponse(questionnaire.id)">Save Answer</button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12" v-else style="transition-delay: 0.4s">
                                <div class="alert alert-success mb-0 text-center">
                                    <span v-if="answered">You have answered this question <i class="far fa-thumbs-up"></i></span>
                                    <span v-else>You have chosen not to answer.</span>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <div class="card-body row" v-else>
                        <div class="col-12 col-lg mb-lg-0">
                            <p>This survey has {{ questionnaire.questions.length }} questions <span v-if="questionnaire.is_anonymous">and is <b>Anonymous</b></span></p>
                            <button class="btn btn-primary mb-0 mt-1 p-3 w-100" @click="openQuestionnaire(questionnaire)">Click here to take it.
                            </button>
                        </div>

                    </div>
                </template>
            </section>
        </div>
        <section v-else class="col-12 card container text-left p-0 mb-4 mt-4 no-surveys">
            <div class="card-body text-center">
                <h5 class="text-center w-100 p-0 m-0">{{ (is_vote === 1 ? no_votes_text : no_survey_text) }}</h5>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Questionnaires',
    props: [
        'user',
        'is_vote'
    ],
    data() {
        return {
            questionnaires: null,
            answered: false,
            completed: [],
            maxOptionLength: 0,
            no_survey_text: "You don't seem to have any Surveys at the moment",
            no_votes_text: "You don't seem to have any Votes at the moment",
            results: {},
            finished: false
        }
    },
    methods: {
        openQuestionnaire(data) {
            this.setPage('Questionnaire');
            this.$questionnaire = data;
        },
        getCurrentQuestionnaires() {
            let self = this,
                url = 'api/questionnaire/getActive';
            if (self.is_vote === 1) {
                url = 'api/vote/getActive';
            }

            axios.get(url, {
                params: {
                    user_id: self.user.id
                }
            }).then(response => {
                if (response.data && response.data.length !== '') {
                    if (response.data.length > 1) {
                        self.heading_text = 'Latest Surveys';
                    }
                    self.questionnaires = response.data;
                    $.each(self.questionnaires, function (key, val) {
                        self.questionnaires[key].questions = JSON.parse(val.questions);
                    })
                }
            });
        },
        saveResponse(answer) {
            $('#q_' + answer.question_id + ' .options.btn-primary').removeClass('btn-primary');

            if (answer && !this.completed.includes(answer.question_id)) {
                this.results[answer.question_id] = {
                    question_id: answer.question_id,
                    option_id: answer.answered.id ? answer.answered.id : null,
                    answer: !answer.answered.id ? answer.answered : null
                };
            }

            $('#a_' + answer.answered.id).addClass('btn-primary');
        },
        postResponse(id) {
            let self = this;

            if (self.results) {
                let formData = new FormData();
                formData.append('user_id', self.user.id);
                formData.append('anonymous', self.user.anonymous);
                formData.append('results', JSON.stringify(self.results));
                axios.post("api/questionnaire/" + id + "/saveresponse", formData).then(response => {
                    if (response.data) {
                        // console.log(response.data);
                        if (response.data.questionnaire.length === 0) {
                            self.finished = true;
                            $('#questionnaire_' + id).fadeOut();
                            setTimeout(function () {
                                self.getCurrentQuestionnaires();
                            }, 1000)
                        } else {
                            if (response.data && response.data.length !== '') {
                                self.results = {};
                                self.questionnaire = response.data.questionnaire;
                                self.questionnaire.questions = JSON.parse(self.questionnaire.questions);
                            }
                        }
                    }
                });
            }
        }
    },
    mounted() {
        $('#anonymous').modal('show');
        let self = this;
        self.getCurrentQuestionnaires();
    },
    created() {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Questionnaires.vue